// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".UserInfo .data-form{min-height:238px}.UserInfo .data-form .input-list .gender{margin-bottom:8px}.UserInfo .data-form .input-list .dob{margin-bottom:16px}", ""]);
// Exports
module.exports = exports;
